export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9081_27989)">
      <g clipPath="url(#clip1_9081_27989)">
        <rect width="16" height="12" transform="translate(0 2)" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2V14H16V2H0Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_9081_27989"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="2"
          width="16"
          height="12"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 2V14H16V2H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_9081_27989)">
          <path
            d="M-1.78125 13.1438L1.73959 14.6328L16.0802 3.62L17.9374 1.40726L14.1723 0.909584L8.32315 5.65532L3.61514 8.85284L-1.78125 13.1438Z"
            fill="white"
          />
          <path
            d="M-1.29883 14.1867L0.49488 15.0508L17.2709 1.20131H14.7523L-1.29883 14.1867Z"
            fill="#F50100"
          />
          <path
            d="M17.7812 13.1438L14.2604 14.6328L-0.0802135 3.62L-1.93738 1.40726L1.82766 0.909584L7.67685 5.65532L12.3849 8.85284L17.7812 13.1438Z"
            fill="white"
          />
          <path
            d="M17.6602 13.8918L15.8664 14.7559L8.72305 8.82618L6.60518 8.16367L-2.11704 1.41407H0.401537L9.11886 8.00347L11.4344 8.79788L17.6602 13.8918Z"
            fill="#F50100"
          />
          <mask id="path-9-inside-1_9081_27989" fill="white">
            <path d="M9.88867 6H17.0137V10H9.88867V15H6.11133V10H-0.986328V6H6.11133V1H9.88867V6Z" />
          </mask>
          <path
            d="M9.88867 6H17.0137V10H9.88867V15H6.11133V10H-0.986328V6H6.11133V1H9.88867V6Z"
            fill="#F50100"
          />
          <path
            d="M9.88867 6H8.88867V7H9.88867V6ZM17.0137 6H18.0137V5H17.0137V6ZM17.0137 10V11H18.0137V10H17.0137ZM9.88867 10V9H8.88867V10H9.88867ZM9.88867 15V16H10.8887V15H9.88867ZM6.11133 15H5.11133V16H6.11133V15ZM6.11133 10H7.11133V9H6.11133V10ZM-0.986328 10H-1.98633V11H-0.986328V10ZM-0.986328 6V5H-1.98633V6H-0.986328ZM6.11133 6V7H7.11133V6H6.11133ZM6.11133 1V0H5.11133V1H6.11133ZM9.88867 1H10.8887V0H9.88867V1ZM9.88867 6V7H17.0137V6V5H9.88867V6ZM17.0137 6H16.0137V10H17.0137H18.0137V6H17.0137ZM17.0137 10V9H9.88867V10V11H17.0137V10ZM9.88867 10H8.88867V15H9.88867H10.8887V10H9.88867ZM9.88867 15V14H6.11133V15V16H9.88867V15ZM6.11133 15H7.11133V10H6.11133H5.11133V15H6.11133ZM6.11133 10V9H-0.986328V10V11H6.11133V10ZM-0.986328 10H0.0136719V6H-0.986328H-1.98633V10H-0.986328ZM-0.986328 6V7H6.11133V6V5H-0.986328V6ZM6.11133 6H7.11133V1H6.11133H5.11133V6H6.11133ZM6.11133 1V2H9.88867V1V0H6.11133V1ZM9.88867 1H8.88867V6H9.88867H10.8887V1H9.88867Z"
            fill="white"
            mask="url(#path-9-inside-1_9081_27989)"
          />
        </g>
      </g>
    </g>
    <rect
      x="0.5"
      y="2.5"
      width="15"
      height="11"
      rx="0.5"
      stroke="black"
      strokeOpacity="0.1"
      style={{ mixBlendMode: 'multiply' }}
    />
    <defs>
      <clipPath id="clip0_9081_27989">
        <rect y="2" width="16" height="12" rx="1" fill="white" />
      </clipPath>
      <clipPath id="clip1_9081_27989">
        <rect width="16" height="12" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
);
